<template>
  <section id="clients" class="clients-section">
    <v-container class="section-container">
      <div class="section-header text-center">
        <span class="section-tag">Доверие лидеров рынка</span>
        <h2 class="section-title">Нам доверяют ведущие рестораны Казахстана</h2>
        <p class="section-description">
          Более 50+ успешных заведений в Алматы, Астане, Шымкенте и Актау уже
          масштабируют выручку и оцифровывают лояльность гостей вместе с
          OZO.direct.
        </p>

        <!-- Категорийный фильтр клиентов (из слайда 12) -->
        <div class="filter-tabs mt-6">
          <button
            v-for="cat in categories"
            :key="cat.id"
            class="filter-btn"
            :class="{ active: selectedCategory === cat.id }"
            @click="selectedCategory = cat.id"
          >
            {{ cat.name }}
          </button>
        </div>
      </div>

      <!-- Сетка карточек клиентов (3 колонки, 15 заведений) -->
      <div class="clients-grid mt-10">
        <div
          v-for="client in filteredClients"
          :key="client.name"
          class="client-card"
        >
          <div class="logo-wrapper img-skeleton-box">
            <img
              :src="client.logo"
              :alt="client.name"
              class="client-logo-img"
              loading="lazy"
              @load="onImgLoad"
            />
          </div>

          <div class="client-info">
            <div class="client-header-line">
              <div class="client-title-group">
                <h4 class="client-name" :title="client.name">
                  {{ client.name }}
                </h4>
                <span v-if="client.subname" class="client-subname">
                  {{ client.subname }}
                </span>
              </div>
              <span class="meta-city">{{ client.city }}</span>
            </div>

            <div class="client-meta-line">
              <span v-if="client.type" class="meta-type">{{
                client.type
              }}</span>
              <span v-if="client.type && client.venues" class="meta-dot"
                >•</span
              >
              <span v-if="client.venues" class="meta-venues">{{
                client.venues
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Цитата / Статистика лояльности (из презентации) -->
      <div class="client-metrics-banner mt-12">
        <v-row align="center" justify="center">
          <v-col cols="6" sm="3">
            <div class="metric-item">
              <span class="m-val">21 000+</span>
              <span class="m-label">Зарегистрированных гостей</span>
            </div>
          </v-col>
          <v-col cols="6" sm="3">
            <div class="metric-item">
              <span class="m-val">50+</span>
              <span class="m-label">Заведений в экосистеме</span>
            </div>
          </v-col>
          <v-col cols="6" sm="3">
            <div class="metric-item">
              <span class="m-val">+25%</span>
              <span class="m-label">Средний прирост выручки</span>
            </div>
          </v-col>
          <v-col cols="6" sm="3">
            <div class="metric-item">
              <span class="m-val d-inline-flex align-center"
                ><i class="ri-star-fill text-warning mr-1"></i>4.9</span
              >
              <span class="m-label">Средняя оценка гостей</span>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "ClientsSection",
  data() {
    return {
      selectedCategory: "all",
      categories: [
        { id: "all", name: "Все заведения" },
        { id: "restaurants", name: "Рестораны" },
        { id: "cafes", name: "Кофейни & Десерты" },
        { id: "bars", name: "Бары & Пабы" },
      ],
      clientColumns: [
        [
          {
            name: "Lavka by Proshenkov",
            type: "Ресторан",
            venues: "3 ресторана",
            city: "Алматы",
            category: "restaurants",
            logo: require("@/assets/presentation/client-lavka.png"),
          },
          {
            name: "Кофемолка",
            type: "Кофейня",
            venues: "2 кофейни",
            city: "Шымкент",
            category: "cafes",
            logo: require("@/assets/presentation/client-kofemolka.png"),
          },
          {
            name: "Irwin bar & grill",
            type: "Гриль-паб",
            venues: "",
            city: "Алматы",
            category: "bars",
            logo: require("@/assets/presentation/client-irwin.png"),
          },
          {
            name: "AG restaurants",
            type: "Сеть ресторанов",
            venues: "4 ресторана",
            city: "Актау",
            category: "restaurants",
            logo: require("@/assets/presentation/client-ag-restaurants.png"),
          },
          {
            name: "wl13bar",
            type: "Бар",
            venues: "",
            city: "Алматы",
            category: "bars",
            logo: require("@/assets/presentation/client-wl13bar.png"),
          },
        ],
        [
          {
            name: "Big Apple",
            type: "Сеть кофеен",
            venues: "",
            city: "Астана",
            category: "cafes",
            logo: require("@/assets/presentation/client-bigapple.jpeg"),
          },
          {
            name: "Coffeeon Saigon",
            type: "Ресторан вьетнамской кухни",
            venues: "",
            city: "Алматы",
            category: "restaurants",
            logo: require("@/assets/presentation/client-saigon.png"),
          },
          {
            name: "CAMP",
            type: "Гастробар",
            venues: "",
            city: "Алматы",
            category: "bars",
            logo: require("@/assets/presentation/client-camp.png"),
          },
          {
            name: "Umami",
            type: "Натуральное мороженое",
            venues: "2 кафе-мороженое",
            city: "Алматы",
            category: "cafes",
            logo: require("@/assets/presentation/client-umami.png"),
          },
          {
            name: "CRAVE Cafe",
            type: "Сеть кофеен",
            venues: "2 кофейни",
            city: "Алматы",
            category: "cafes",
            logo: require("@/assets/presentation/client-crave.jpeg"),
          },
        ],
        [
          {
            name: "BETWEEN",
            type: "Fast & Smart Food",
            venues: "4 кофейни",
            city: "Алматы",
            category: "cafes",
            logo: require("@/assets/presentation/client-between.png"),
          },
          {
            name: "Ragout",
            type: "Магазин здорового питания",
            venues: "1 магазин",
            city: "Алматы",
            category: "restaurants",
            logo: require("@/assets/presentation/client-ragout.png"),
          },
          {
            name: "PINTA Club",
            type: "Сеть ресторанов",
            venues: "18 ресторанов",
            city: "Алматы",
            category: "restaurants",
            logo: require("@/assets/presentation/client-pinta.png"),
          },
          {
            name: "Jeti",
            subname: "RIZA GROUP",
            type: "Ресторан",
            venues: "",
            city: "Актау",
            category: "restaurants",
            logo: require("@/assets/presentation/client-riza.png"),
          },
          {
            name: "Fort Vernyi",
            type: "Сеть ресторанов",
            venues: "2 ресторана",
            city: "Алматы",
            category: "restaurants",
            logo: require("@/assets/presentation/client-fortvernyi.jpeg"),
          },
        ],
      ],
    };
  },
  computed: {
    // Раскладка по строкам для сетки 3x5:
    // Строка 1: [Колонка 1 (1)], [Колонка 2 (6)], [Колонка 3 (11)]
    // Строка 2: [Колонка 1 (2)], [Колонка 2 (7)], [Колонка 3 (12)]
    // ...
    // Это гарантирует идеальное выравнивание строк и сохраняет 3 колонки из списка
    orderedClients() {
      const list = [];
      for (let r = 0; r < 5; r++) {
        for (let c = 0; c < 3; c++) {
          if (this.clientColumns[c] && this.clientColumns[c][r]) {
            list.push(this.clientColumns[c][r]);
          }
        }
      }
      return list;
    },
    filteredClients() {
      if (this.selectedCategory === "all") {
        return this.orderedClients;
      }
      return this.orderedClients.filter(
        (client) => client.category === this.selectedCategory
      );
    },
  },
  mounted() {
    this.checkImagesLoaded();
  },
  updated() {
    this.$nextTick(() => {
      this.checkImagesLoaded();
    });
  },
  methods: {
    onImgLoad(e) {
      if (e && e.target) {
        e.target.classList.add("is-loaded");
        if (e.target.parentElement) {
          e.target.parentElement.classList.add("is-loaded");
        }
      }
    },
    checkImagesLoaded() {
      this.$nextTick(() => {
        this.$el.querySelectorAll(".client-logo-img").forEach((img) => {
          if (img.complete && img.naturalWidth > 0) {
            img.classList.add("is-loaded");
            if (img.parentElement) img.parentElement.classList.add("is-loaded");
          }
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.clients-section {
  background-color: $color-bg-white;
  padding: $section-py 0;

  @media (max-width: 960px) {
    padding: $section-py-mobile 0;
  }
}

.section-container {
  max-width: $container-max-width;
  margin: 0 auto;
}

.section-tag {
  display: inline-block;
  color: #0b7a3a;
  background: $color-neon-green-soft;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 6px 14px;
  border-radius: $radius-full;
  margin-bottom: 12px;
}

.section-title {
  font-family: $font-family-heading;
  font-size: 38px;
  font-weight: 800;
  color: $color-text-dark;
  margin-bottom: 16px;

  @media (max-width: 960px) {
    font-size: 28px;
  }
}

.section-description {
  font-size: 16px;
  color: $color-text-secondary;
  max-width: 720px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Filter Tabs */
.filter-tabs {
  display: inline-flex;
  background: #f1f5f9;
  padding: 4px;
  border-radius: $radius-full;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 480px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4px;
    border-radius: $radius-md;
    width: 100%;
  }

  .filter-btn {
    border: none;
    background: transparent;
    padding: 8px 20px;
    border-radius: $radius-full;
    font-size: 13px;
    font-weight: 600;
    color: #475569;
    cursor: pointer;
    transition: all 0.2s ease;

    @media (max-width: 480px) {
      border-radius: $radius-sm;
      padding: 8px 6px;
      font-size: 12px;
      text-align: center;
    }

    &.active {
      background: #ffffff;
      color: $color-text-dark;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      font-weight: 700;
    }
  }
}

/* Clients Grid - 3 columns, perfectly uniform cards */
.clients-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}

.client-card {
  background: #ffffff;
  border: 1px solid #eef0f3;
  border-radius: $radius-md;
  height: 84px;
  min-height: 84px;
  max-height: 84px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.02);
  transition: all 0.25s ease;
  box-sizing: border-box;

  &:hover {
    border-color: rgba(0, 230, 118, 0.5);
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);

    .client-logo-img {
      filter: grayscale(0%);
      transform: scale(1.05);
    }
  }

  .logo-wrapper {
    height: 58px;
    width: 64px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8fafc;
    border: 1px solid #f1f5f9;
    border-radius: $radius-sm;
    padding: 6px;
    box-sizing: border-box;

    .client-logo-img {
      max-height: 44px;
      max-width: 52px;
      object-fit: contain;
      filter: grayscale(12%);
      transition: all 0.25s ease;
    }
  }

  .client-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
    flex-grow: 1;
    overflow: hidden;
  }

  .client-header-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 5px;
    min-width: 0;
  }

  .client-title-group {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    overflow: hidden;
  }

  .client-name {
    font-family: $font-family-heading;
    font-size: 14.5px;
    font-weight: 700;
    color: $color-text-dark;
    line-height: 1.2;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .client-subname {
    font-size: 10px;
    font-weight: 700;
    color: #0b7a3a;
    background: rgba(0, 230, 118, 0.15);
    padding: 1px 5px;
    border-radius: $radius-xs;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .meta-city {
    font-size: 11px;
    font-weight: 600;
    color: #475569;
    background: #f1f5f9;
    padding: 2px 7px;
    border-radius: $radius-full;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .client-meta-line {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    color: $color-text-secondary;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .meta-type {
      color: #64748b;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .meta-venues {
      color: #94a3b8;
      white-space: nowrap;
      flex-shrink: 0;
    }

    .meta-dot {
      color: #cbd5e1;
      font-size: 8px;
      flex-shrink: 0;
    }
  }
}

/* Metrics Banner */
.client-metrics-banner {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: $radius-lg;
  padding: 30px 20px;

  @media (max-width: 600px) {
    padding: 20px 10px;
  }

  .metric-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 20px;

    @media (max-width: 600px) {
      padding: 8px 4px;
    }

    .m-val {
      font-family: $font-family-heading;
      font-size: 32px;
      font-weight: 900;
      color: #0b7a3a;
      line-height: 1.1;
      margin-bottom: 4px;

      @media (max-width: 600px) {
        font-size: 22px;
      }
    }

    .m-label {
      font-size: 13px;
      color: #64748b;
      font-weight: 500;
      text-align: center;

      @media (max-width: 600px) {
        font-size: 11px;
      }
    }
  }
}
</style>
